<script lang="ts" setup></script>

<template>
    <q-header class="bg-background text-on-background" elevated>
        <div class="q-px-md q-py-lg-sm">
            <q-toolbar class="full-height row justify-start page-container q-px-none q-py-xs">
                <app-drawer-navigation-btn class="lt-lg" />
                <logo-img class="gt-md block" clickable />
                <q-space />
                <app-header-navigation />
                <app-user-navigation />
            </q-toolbar>
        </div>
    </q-header>
</template>
